module.exports = __webpack_public_path__ + "static/media/sign-in-icon.679f2a77.svg";